export default {
    ActiveWebWidgetAccount: {},
    WebWidgetAccounts: [],
    WebWidgetFlows: [],
    webWidgetAccountObjTmp: {}
}